<template>
  <div class="v-level --is-level-3 --is-mobile">
    <Heading title="Selbst zusammenstellen" subtitle="Sie bestimmen jede Delikatesse." level="3" />

    <LevelCatalog
      ref="catalog"
      :listItems="listItems"
    />

    <PresentContentMobile />
  </div>
</template>

<script>
import Heading from '@/components/Heading';
import LevelCatalog from '@/components/LevelCatalog';
import PresentContentMobile from '@/components/PresentContentMobile';
import { logicMixin } from '@/mixins/LogicMixin';
import { getPriceLevel3 } from '@/helper/functions.js';

export default {
  components: {
    Heading,
    LevelCatalog,
    PresentContentMobile
  },
  mixins: [logicMixin],
  methods: {
    selectedIsInList() {
      var allInList = true;
      if (this.$store.getters.getSelectedItem.data !== null) {
        this.$store.getters.getSelectedItem.data.products.forEach(element => {
          var eInList = false;
          this.$store.getters.getListItemsLevel3.forEach(element2 => {
            if (element.id === element2.id) {
              eInList = true;
            }
          });

          if (!eInList) {
            allInList = false;
          }
        });
      }

      return allInList;
    }
  },
  computed: {
    listItems() {
      return this.$store.getters.getListItemsLevel3Filtered.filter((
        product
      ) => {
        const price = getPriceLevel3(product, this.$store.getters.getUserGroupId, !this.$store.getters.getLevel3Filter.useB2cPrices);
        if (
          price >= this.$store.getters.getLevel3Filter.priceMin &&
                  price <= this.$store.getters.getLevel3Filter.priceMax
        ) {
          return true;
        }
        return false;
      });
    }
  }
};
</script>
